module.exports = __webpack_public_path__ + "img/bianYaQi4.a1f125c5.png";